import React from 'react';

import useIsMinBreakpoint from '@hero/react-hooks/mediaQuery/useIsMinBreakpoint';
import { useFormContext } from '@hero/ui-kit/inputs/Form';
import Input from '@hero/ui-kit/inputs/Input';
import Container from '@hero/ui-kit/layout/Container';
import Section from '@hero/ui-kit/layout/Section';
import P from '@hero/ui-kit/typography/P';
import useGetLeadInsurance from '../../../../../api/useGetLeadInsurance';
import DOB from '../../../../../components/LeadsForm/fields/DOB';
import { LeadDetailsResponse, LeadInsuranceResponse } from '../../../../../types';

interface PatientDetailsFormProps {
    isLoading?: boolean;
    errorType?: string;
    lead?: LeadDetailsResponse;
    canEdit?: boolean;
}

const FormElements: React.FC<{
    isSaveDisabled?: boolean;
    leadInsurance?: LeadInsuranceResponse;
    lead?: LeadDetailsResponse;
    canEdit?: boolean;
}> = ({ canEdit }) => {
    const isMinL = useIsMinBreakpoint('l');

    const {
        setValue,
        formState: { isDirty }
    } = useFormContext();

    React.useEffect(() => {
        setValue('isDirty', isDirty);
    }, [setValue, isDirty]);

    const disabled = !canEdit;

    return (
        <>
            <Section noDefaultPadding>
                <div style={{ width: '100%', textAlign: 'left', marginBottom: 'var(--gutter)' }}>
                    <P
                        noDefaultMargin
                        strong
                        styles={{ fontSize: '2.4rem', marginBottom: '3.6rem' }}
                    >
                        Program applicant
                    </P>
                </div>
                <Container gridTemplateColumns={isMinL ? '1fr 1fr' : '1fr'} gridColumnGap="regular">
                    <Input disabled={disabled} name="first_name" displayName="First Name" />
                    <Input disabled={disabled} name="last_name" displayName="Last Name" />
                </Container>
                <Container gridTemplateColumns={isMinL ? '1fr 1fr' : '1fr'} gridColumnGap="regular">
                    <DOB displayName="Date of birth (MM-DD-YYYY)" disabled={disabled} />
                    <Input disabled={disabled} name="zip_code" displayName="zip" />
                </Container>
                <Container gridTemplateColumns={isMinL ? '1fr 1fr' : '1fr'} gridColumnGap="regular">
                    <Input disabled={disabled} name="patient_email" displayName="Patient Email" />
                    <Input
                        disabled={disabled}
                        name="patient_phone"
                        displayName="Patient Phone number"
                    />
                </Container>
                <Input
                    disabled={disabled}
                    name="external_user_id"
                    displayName="Patient ID (optional)"
                />
            </Section>
        </>
    );
};

const PatientDetailsForm: React.FC<PatientDetailsFormProps> = ({ isLoading, lead, canEdit }) => {
    const { data: leadInsurance } = useGetLeadInsurance(lead?.primary_user_details.lead_id || '');

    return (
        <>
            <FormElements
                leadInsurance={leadInsurance}
                isSaveDisabled={isLoading}
                lead={lead}
                canEdit={canEdit}
            />
        </>
    );
};

export default PatientDetailsForm;
